// Missing rights are denied; the router refreshes capabilities from the authenticated backend.
export function canOpenPaymentRoute(access, routeName) {
  if (!access || (!access.Payment && !access.Gateway)) return false;
  if (routeName === "company-admin-gateway-orders") return access.Gateway === true;
  if (access.Payment) return true;
  return ["company-admin-TransactionReport", "company-admin-pos-definitions", "company-admin-payment-sets"].includes(routeName);
}
